/*
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2022, Zumper
 */

import { useDispatch as _useDispatch } from 'react-redux'
import type { Dispatch } from './types'

export const useDispatch = (): Dispatch => _useDispatch()
